import {LanguageResponse} from '@contentlab/api/project/types';
import projectFetchers from '@/api/fetchers/content-studio/project';
import useReactQuery from '@/hooks/use-react-query';
import {CONTENT_LAB, CAPTIONS_LANGUAGES} from '../consts';

function useCaptionsLanguagesQuery() {
  return useReactQuery<LanguageResponse[]>({
    queryKey: [CONTENT_LAB, CAPTIONS_LANGUAGES],
    queryFn: async () => {
      const response = await projectFetchers.getCaptionLanguages();
      return response || [];
    },
  });
}

export default useCaptionsLanguagesQuery;
